module.exports = __webpack_public_path__ + "img/formulaEle.3b919d1b.svg";